import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { MOBILE_MAX, mediaHelper } from '@property.com.au/ui-kit';
import { useMediaGalleryLightBoxContext } from '../../../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';
import { isHopefullyDomEnvironment } from '../../../../../helpers/IsHopefullyDomEnvironment';
import { DefineAdSlot } from '../../../../../app-kit/components/DefineAdSlot/DefineAdSlot';
import { mapSlotConfigFromVariant } from './helpers/mapSlotConfigFromVariant';

const AdvertisementContainer = styled.div`
  height: 148px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${mediaHelper('tabletMin')} {
    display: none;
  }
`;

export const MediaGalleryMobileAd: FunctionComponent = () => {
  const { propertyPageBySlugData } = useMediaGalleryLightBoxContext();
  const mobileAd = propertyPageBySlugData?.mediaGalleryV2?.mobileAd;

  if (!mobileAd || !isHopefullyDomEnvironment() || window.innerWidth > MOBILE_MAX) {
    return null;
  }

  return (
    <AdvertisementContainer data-testid="MediaGalleryMobileAd">
      <DefineAdSlot slotConfig={mapSlotConfigFromVariant(mobileAd.variant)} />
    </AdvertisementContainer>
  );
};
